import { Logo as SharedLogo } from '@rockalingua/ui';

export default function Logo({ href }) {
  return <SharedLogo href={href} />;
}
